import type { FaireProductEntity } from "../../entity_types/product";

export const p_cw59vqvskq: FaireProductEntity = {
  token: "p_cw59vqvskq",
  type: "product",
  name: "S925 Silver Gold Plated Zircon Knot Double Layer Ring",
  brandToken: "b_9a7m2r54fa",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/7ef1656d65755c3c8aa94af72ba29ffa0ed9b4654726bad3a7ef455dbb22fd1a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/794cf2c45cf4e68a86eb22cd4f3df8e033835f35fc0839d1747ea9db2310f3dc.jpeg",
    "https://cdn.faire.com/fastly/834baf3854d91f6a2a56a4c144a82a55a5b4efa9e48409d84b634f5862f20a54.jpeg",
    "https://cdn.faire.com/fastly/b2da150125b8f30d448993ac22e388839c9b3b50d0be2f8d71534b1aaa2137fb.jpeg",
  ],
  priceDollars: 18.02,
  description:
    "'-ID: GIO-SZXDF-RI2501\n-Material: S925 Sterling Silver White Gold Plated\n-Stone(s): Cubic Zirconia\n-Size: 6, 7, 8, 9, 10 (Standard US Size)\n-Weight(s): 1g\n-Quality: Excellent\n-Lead Free, -Nickel Free\nPackaging: Transparent PE Seal Bag",
  tags: [],
  msrpDollars: 36.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:23.564Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
